{
  "version": 1,
  "asset_id": "acef8150-9931-405c-815a-7ad662bef39e",
  "project_id": "affbb9b7-8892-4de7-a6a3-a24f8c559459",
  "url": "/__l5e/assets-v1/acef8150-9931-405c-815a-7ad662bef39e/pulizia-cotto-portico-prima-brescia.webp",
  "r2_key": "a/v1/affbb9b7-8892-4de7-a6a3-a24f8c559459/acef8150-9931-405c-815a-7ad662bef39e/pulizia-cotto-portico-prima-brescia.webp",
  "original_filename": "pulizia-cotto-portico-prima-brescia.webp",
  "size": 249632,
  "content_type": "image/webp",
  "created_at": "2026-09-02T15:12:07Z"
}
